var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-blue-900 p-4 lg:p-12"},[_c('div',{staticClass:"max-w-full mx-auto"},[_vm._t("hero")],2)]),_c('div',{staticClass:"p-4 lg:p-12"},[_c('div',{staticClass:"max-w-full mx-auto"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }